import React, { useEffect } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import InvoicesTable from '../../InvoicesResearch/InvoicesTable';
import ApiService from '../../../services/ApiService';

import useStyles from './styles';

export default function InvoicesList(props) {
  const { ticketNumber, expanded, handleChange } = props;
  const [invoices, setInvoices] = React.useState([]);
  const [total, setTotal] = React.useState('');

  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    const query = `?ticketNumber=${ticketNumber}`;
    ApiService.searchInvoicesByQueries(query).then((response) => {
      setInvoices(response.data);
      let amount = 0.0;
      response.data.forEach((invoice) => {
        amount += invoice.amount;
      });
      setTotal(`${Math.round(amount * 100) / 100} €`);
    });
  }, [ticketNumber]);

  return (
    <div>
      {invoices.length > 0 && (
        <Accordion
          className={classes.accordion}
          expanded={expanded}
          onChange={handleChange}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          >
            <Typography className={classes.heading}>{t('Invoices')}</Typography>
            <Typography className={classes.secondaryHeading}>
              {t('Invoices details')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.container}>
            <InvoicesTable
              ticketDetailsPage
              initialInvoices={invoices}
              setSelectedInvoices={null}
              selectAll={null}
            />
            <Grid container spacing={0}>
              <Grid item xs={10} />
              <Grid
                item
                xs={2}
                container
                alignItems="center"
                justify="flex-end"
              >
                <div className={classes.totalDiv}>
                  <Typography className={classes.totalLabel}>
                    {t('Total amount')}
                  </Typography>
                  <Typography className={classes.totalAmount}>
                    {total}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
